
    <template>
      <section class="relax-doc">
        <h1>Slider 滑动块</h1>
<blockquote>
<p>滑动范围输入控件</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>拖动滑块时，显示数值</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-slider v-model=&quot;value&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
import {ref} from 'vue'
export default {
  setup(){
    const value = ref(20)

    return {
      value,
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="fan-wei-xuan-ze"><a class="header-anchor" href="#fan-wei-xuan-ze"></a> 范围选择</h2>
<blockquote>
<p><code>min</code> 和 <code>max</code> 可以限制最小值和最大值</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-slider :min=&quot;5&quot; :max=&quot;10&quot; v-model=&quot;value&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
import {ref} from 'vue'
export default {
  setup(){
    const value = ref(8)

    return {
      value,
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="shuang-hua-kuai"><a class="header-anchor" href="#shuang-hua-kuai"></a> 双滑块</h2>
<blockquote>
<p>当<code>v-model</code>的值为<code>array</code>类型时，开启双滑块</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-slider :min=&quot;5&quot; :max=&quot;20&quot; v-model=&quot;value&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
import {reactive} from 'vue'
export default {
  setup(){
    const value = reactive([10, 15])

    return {
      value,
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="xian-shi-jian-ge"><a class="header-anchor" href="#xian-shi-jian-ge"></a> 显示间隔</h2>
<blockquote>
<p>设置<code>step</code>显示间隔</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-slider :min=&quot;5&quot; :max=&quot;10&quot; step v-model=&quot;value&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
import {ref} from 'vue'
export default {
  setup(){
    const value = ref(6)

    return {
      value,
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="xian-shi-tooltip"><a class="header-anchor" href="#xian-shi-tooltip"></a> 显示ToolTip</h2>
<blockquote>
<p>当 <code>show-tooltip</code> 为 <code>true</code> 时，将始终显示<code>ToolTip</code>；反之则始终不显示，即使在拖动、移入时也是如此。</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo4 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-slider :min=&quot;5&quot; :max=&quot;20&quot; v-model=&quot;value&quot; show-tooltip /&gt;
&lt;/template&gt;

&lt;script&gt;
import {reactive} from 'vue'
export default {
  setup(){
    const value = reactive([10, 15])

    return {
      value,
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_slider = _resolveComponent("x-slider")

  return (_openBlock(), _createBlock(_component_x_slider, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event)
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
const democomponentExport = {
  setup(){
    const value = ref(20)

    return {
      value,
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_slider = _resolveComponent("x-slider")

  return (_openBlock(), _createBlock(_component_x_slider, {
    min: 5,
    max: 10,
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event)
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
const democomponentExport = {
  setup(){
    const value = ref(8)

    return {
      value,
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_slider = _resolveComponent("x-slider")

  return (_openBlock(), _createBlock(_component_x_slider, {
    min: 5,
    max: 20,
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event)
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {reactive} = Vue
        
const democomponentExport = {
  setup(){
    const value = reactive([10, 15])

    return {
      value,
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_slider = _resolveComponent("x-slider")

  return (_openBlock(), _createBlock(_component_x_slider, {
    min: 5,
    max: 10,
    step: "",
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event)
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
const democomponentExport = {
  setup(){
    const value = ref(6)

    return {
      value,
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_slider = _resolveComponent("x-slider")

  return (_openBlock(), _createBlock(_component_x_slider, {
    min: 5,
    max: 20,
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event),
    "show-tooltip": ""
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {reactive} = Vue
        
const democomponentExport = {
  setup(){
    const value = reactive([10, 15])

    return {
      value,
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  